var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"page-main__inner"},[_c('section',{staticClass:"page-section"},[_c('div',{staticClass:"page-user__content page-inner"},[(_vm.user)?_c('UserDetail',{attrs:{"user":_vm.user}}):_vm._e(),(_vm.user)?_c('UserMap',{attrs:{"user":_vm.user}}):_vm._e()],1)])])
}
var staticRenderFns = []

export { render, staticRenderFns }